export class FileService {
    getFile(name: string) {
        return name;
        // Check if the URL is already an S3 URL
        // if (name.includes('amazonaws.com')) {
        //     return name;
        // }
        // // If it's not an S3 URL, assume it's a relative path and construct the full URL
        // return `${process.env.REACT_APP_SERVER_URL}/files/${name}`;
    }
}
